import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordUtilizationDataClassName = DataClassName.TIMERECORD_UTILIZATION
const timerecordUtilizationEndpoint =
  PisaDataClassEndpoint.TIMERECORD_UTILIZATION

export function pisaTimerecordUtilizationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(timerecordUtilizationDataClassName, {
    title: timerecordUtilizationDataClassName,
    restApi: createPisaRestApiConfig(timerecordUtilizationEndpoint),
    attributes,
  })
}
